import React from "react";
import { useTranslation } from "react-i18next";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

export const DEFAULT_SMS_MSG_HEADER = "SERVISTESIN";

export const SMS_MSG_HEADER_OPTIONS = ["SERVISTESIN", "CETINTUR", "ANKAWRLDLTD"];
// export const SMS_MSG_HEADER_OPTIONS = ["SERVISTESIN", "CETINTUR"];

/**
 * NETGSM sender account (msg header). Value is the API msgheader string.
 */
const SmsSenderAccountSelect = ({ value, onChange, disabled = false, fullWidth = true, size = "small", sx }) => {
  const { t } = useTranslation();
  const selectId = "sms-sender-account-select";

  return (
    <FormControl fullWidth={fullWidth} size={size} sx={sx}>
      <InputLabel id={`${selectId}-label`}>{t("smsSenderAccount")}</InputLabel>
      <Select
        labelId={`${selectId}-label`}
        id={selectId}
        value={value || DEFAULT_SMS_MSG_HEADER}
        label={t("smsSenderAccount")}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
        {SMS_MSG_HEADER_OPTIONS.map((h) => (
          <MenuItem key={h} value={h}>
            {h}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SmsSenderAccountSelect;
